import React, { Component,Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Spinner from '../app/shared/Spinner';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));

const Buttons = lazy(() => import('./basic-ui/Buttons'));
const Dropdowns = lazy(() => import('./basic-ui/Dropdowns'));
const Typography = lazy(() => import('./basic-ui/Typography'));

const BasicElements = lazy(() => import('./form-elements/BasicElements'));

const BasicTable = lazy(() => import('./tables/BasicTable'));

const Mdi = lazy(() => import('./icons/Mdi'));

const ChartJs = lazy(() => import('./charts/ChartJs'));

const Error404 = lazy(() => import('./error-pages/Error404'));
const Error500 = lazy(() => import('./error-pages/Error500'));

const Login = lazy(() => import('./user-pages/Login'));
const Register1 = lazy(() => import('./user-pages/Register'));
const Users = lazy(() => import('./user-pages/Users'));

// Inventory / Kardex
const Inventory = lazy(() => import('./inventory/Inventory'));
const KardexMovements = lazy(() => import('./inventory/KardexMovements'));
const DocumentRegister = lazy(() => import('./inventory/DocumentRegister'));
const Suppliers = lazy(() => import('./inventory/Suppliers'));
const ElectronicInvoices = lazy(() => import('./einvoice/ElectronicInvoices'));
const ElectronicInvoiceCreate = lazy(() => import('./einvoice/ElectronicInvoiceCreate'));
const ElectronicGuides = lazy(() => import('./einvoice/ElectronicGuides'));
const ElectronicNotes = lazy(() => import('./einvoice/ElectronicNotes'));

const ElectronicQuotations = lazy(() => import('./einvoice/ElectronicQuotations'));
const ElectronicQuotationCreate = lazy(() => import('./einvoice/ElectronicQuotationCreate'));

const isAuthenticated = () => {
  try {
    const raw = localStorage.getItem('kardex_user');
    return Boolean(raw);
  } catch (error) {
    return false;
  }
};

const RootRoute = (props) => (
  isAuthenticated()
    ? <Redirect to="/dashboard" />
    : <Login {...props} />
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      isAuthenticated()
        ? <Component {...props} />
        : <Redirect to="/" />
    )}
  />
);


class AppRoutes extends Component {
  render () {
    return (
      <Suspense fallback={<Spinner/>}>
        <Switch>
          <Route exact path="/" component={ RootRoute } />
          <PrivateRoute exact path="/dashboard" component={ Dashboard } />

          <PrivateRoute path="/inventory/products" component={ Inventory } />
          <PrivateRoute path="/inventory/suppliers" component={ Suppliers } />
          <PrivateRoute path="/inventory/kardex-movements" component={ KardexMovements } />
          <PrivateRoute path="/inventory/document-register" component={ DocumentRegister } />
          <PrivateRoute path="/einvoice/invoices/new" component={ ElectronicInvoiceCreate } />
          <PrivateRoute path="/einvoice/invoices" component={ ElectronicInvoices } />
          <PrivateRoute path="/einvoice/quotations/new" component={ ElectronicQuotationCreate } />
          <PrivateRoute path="/einvoice/quotations" component={ ElectronicQuotations } />
          <PrivateRoute path="/einvoice/guides" component={ ElectronicGuides } />
          <PrivateRoute path="/einvoice/notes" component={ ElectronicNotes } />

          <Route path="/basic-ui/buttons" component={ Buttons } />
          <Route path="/basic-ui/dropdowns" component={ Dropdowns } />
          <Route path="/basic-ui/typography" component={ Typography } />

          <Route path="/form-Elements/basic-elements" component={ BasicElements } />

          <Route path="/tables/basic-table" component={ BasicTable } />

          <Route path="/icons/mdi" component={ Mdi } />

          <Route path="/charts/chart-js" component={ ChartJs } />


          <Route path="/user-pages/login-1" component={ Login } />
          <Route path="/user-pages/register-1" component={ Register1 } />
          <PrivateRoute path="/user-pages/users" component={ Users } />

          <Route path="/error-pages/error-404" component={ Error404 } />
          <Route path="/error-pages/error-500" component={ Error500 } />


          <Redirect to="/" />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;